<template>
  <div v-if="file">
    <div class="hpanel">
      <div class="panel-heading">
        File overview
      </div>
      <div class="panel-body">
        <div class="row">
          <div class="col-xs-12 col-lg-7 m-b">
            <label>Name</label>
            <div>
              <a :href="file.link" target="_blank">{{file.name}}</a>
            </div>
          </div>
          <div class="col-xs-12 col-lg-5 m-b">
            <label>Extension</label>
            <div>{{file.extension}}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12 col-lg-7 m-b">
            <label>Owner</label>
            <div>{{file.user.firstname }} {{file.user.lastname }}</div>
          </div>
          <div class="col-xs-12 col-lg-5 m-b">
            <label>Project</label>
            <div v-if="file.project">
              <router-link :to="{name: 'ProjectDetails', params: {id: file.project_id}}">
                {{file.project.name}}
              </router-link>
            </div>
            <div v-else>n.a</div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12 col-lg-7 m-b">
            <label>Content</label>
            <div v-if="file.asynchronous_file && file.asynchronous_file.origin">{{file.asynchronous_file.origin.replace('_', ' ')}}</div>
            <div v-else>Other (external)</div>
          </div>
          <div class="col-xs-12 col-lg-5 m-b">
            <label>Status</label>
            <div v-if="file.asynchronous_file && file.asynchronous_file.status">
              <span v-if="file.asynchronous_file.status === 'PENDING'" class="label label-warning">{{ file.asynchronous_file.status }}</span>
              <span v-if="file.asynchronous_file.status === 'RUNNING'" class="label label-info">{{ file.asynchronous_file.status }}</span>
              <span v-if="file.asynchronous_file.status === 'FINISHED'" class="label label-success">{{ file.asynchronous_file.status }}</span> <br>
              <span v-if="file.asynchronous_file.status === 'ERROR'" class="label label-danger">{{ file.asynchronous_file.status }}</span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12 col-lg-7 m-b">
            <label>Created at</label>
            <div>{{file.created_at | moment('LLL')}}</div>
          </div>
          <div class="col-xs-12 col-lg-5 m-b">
            <label>Updated at</label>
            <div>{{file.updated_at | moment('LLL')}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="hpanel" v-if="file.asynchronous_file && file.asynchronous_file.status_upload !== null">
      <div class="panel-heading">
        Upload overview
      </div>
      <div class="panel-body">
        <div class="row">
          <div class="col-xs-12 col-lg-7">
            <label>uploaded at</label>
            <div>{{file.updated_at | moment('LLL')}}</div>
          </div>
          <div class="col-xs-12 col-lg-5">
            <label>Status</label>
            <div v-if="file.asynchronous_file && file.asynchronous_file.status_upload">
              <span v-if="file.asynchronous_file.status_upload === 'PENDING'" class="label label-warning">{{ file.asynchronous_file.status_upload }}</span>
              <span v-if="file.asynchronous_file.status_upload === 'RUNNING'" class="label label-info">{{ file.asynchronous_file.status_upload }}</span>
              <span v-if="file.asynchronous_file.status_upload === 'FINISHED'" class="label label-success">{{ file.asynchronous_file.status_upload }}</span> <br>
              <span v-if="file.asynchronous_file.status_upload === 'ERROR'" class="label label-danger">{{ file.asynchronous_file.status_upload }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="hpanel" v-if="file.timestamped_file">
      <div class="panel-heading">
        Protection overview
      </div>
      <div class="panel-body">
        <div class="row">
          <div class="col-xs-12 m-b">
            <label> Title</label>
            <div v-html="file.timestamped_file.title"></div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12 m-b">
            <label>Description</label>
            <div v-if="file.timestamped_file.description" v-html="file.timestamped_file.description"></div>
            <div v-else>Empty</div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 m-b">
            <label>File Type</label>
            <div>
              <template v-if="file.timestamped_file.type">
                {{file.timestamped_file.type.name }}
              </template>
              <template v-else>
                Platform Content
              </template>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 m-b">
            <label>File Added</label>
            <div v-if="file.timestamped_file.is_manually_added">Manually</div>
            <div v-else> Automatically</div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12 m-b" v-if="file.timestamped_file.tags">
            <label>Project tags</label>
            <div v-html="file.timestamped_file.tags"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 m-b">
            <label>File name</label>
            <div>{{file.name}}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 m-b" v-if="file.timestamped_file.owners">
            <label>Owners</label>
            <div v-for="(owner, key) in file.timestamped_file.owners" :key="key">
              <span>{{owner.first_name}} {{owner.last_name}}</span> <span v-if="owner.organisation_name">({{owner.organisation_name}})</span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12 col-lg-7 m-b">
            <label>Uploaded At</label>
            <div>{{file.timestamped_file.created_at | moment("dddd, MMMM Do YYYY, h:mm:ss")}}</div>
          </div>

          <div class="col-xs-12 col-lg-5 m-b">
            <label>Status</label>
            <div>
              <span v-if="file.timestamped_file.status === 'PENDING'" class="label label-warning">{{ file.timestamped_file.status }}</span>
              <span v-if="file.timestamped_file.status === 'RUNNING'" class="label label-info">{{ file.timestamped_file.status }}</span>
              <template v-if="file.timestamped_file.status === 'FINISHED'">
                <span  class="label label-success">PROTECTED</span>
              </template>
              <span v-if="file.timestamped_file.status === 'ERROR'" class="label label-danger">{{ file.timestamped_file.status }}</span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12 m-b">
            <label>Fingerprint</label>
            <div v-html="file.hash"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-lg-7 m-b">
            <label>Blockchain Url</label>
            <div>
              <a style="text-overflow: ellipsis;overflow: hidden;display: block" :href="file.timestamped_file.certification_url" target="_blank">{{file.timestamped_file.certification_url}}</a>
            </div>
          </div>

          <div class="col-xs-12 col-lg-5  m-b" v-if="file.timestamped_file.status === 'FINISHED'">
            <label>Proof of existence</label>
            <div>
              <router-link :to="{name: 'TimestampedFileCertification', params: {poe_id: file.timestamped_file.id}}"  target="_blank">Generate it</router-link>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<style scoped>
.table td {
  vertical-align: middle !important;
}
</style>
<script>

export default {
  components: {},
  name: 'Details',
  props: {
    file_id: {
      require: true,
      default: null
    }
  },
  data () {
    return {
      file: null
    }
  },
  methods: {
    getResources: function () {
      this.axios.get('file/' + this.file_id + '?relations={project,user,asynchronousFile,timestampedFile.type}').then((response) => {
        this.file = response.data
      }).catch((error) => {
        if (error.response.status === 403) {
          this.$router.replace({name: 'Error403', params: {'0': ''}})
        }
        if (error.response.status === 404) {
          this.$router.replace({name: 'Error404', params: {'0': ''}})
        }
      })
    }
  },
  beforeMount () {
    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/file/Details.vue